export const langMap = {
  en: 'en',
  'zh-cn': 'zh_cn',
  'zh-hk': 'zh_tw',
};
